import { render, staticRenderFns } from "./RescheduleSetting.vue?vue&type=template&id=67955dcc&scoped=true"
import script from "./RescheduleSetting.vue?vue&type=script&lang=js"
export * from "./RescheduleSetting.vue?vue&type=script&lang=js"
import style0 from "./RescheduleSetting.vue?vue&type=style&index=0&id=67955dcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67955dcc",
  null
  
)

export default component.exports